import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "export",
  "use": "export-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"export\"><g stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M6 13l6-5.97L6 1M12 7H0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id